import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

/**
 * AuthContext — three states:
 *   null  → loading (still checking existing session)
 *   {...} → authenticated user
 *   false → not authenticated
 */
const AuthContext = createContext({ user: null, login: async () => {}, logout: async () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading

  const refresh = useCallback(async () => {
    try {
      const me = await api.me();
      setUser(me);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const r = await api.login(email, password);
    setUser(r.user);
    return r.user;
  };

  const logout = async () => {
    try { await api.logout(); } catch { /* ignore */ }
    setUser(false);
    // hard nav to clear in-memory state
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
